import { z } from "zod/v4";

import { TestShippingSchema } from "../../../schemas/test-shipping";

export const PatchTestShippingRequestPathParamSchema = z.object({
  testShippingId: z.uuid(),
});

export type PatchTestShippingRequestPathParamType = z.infer<
  typeof PatchTestShippingRequestPathParamSchema
>;

export const PatchTestShippingRequestBodySchema = TestShippingSchema.partial();

export type PatchTestShippingRequestBodyType = z.infer<
  typeof PatchTestShippingRequestBodySchema
>;

export const PatchTestShippingResponseBodySchema = z.object({
  testShipping: TestShippingSchema,
});

export type PatchTestShippingResponseBodyType = z.infer<
  typeof PatchTestShippingResponseBodySchema
>;
